const LOCAL_STORAGE = {
  guide: {
    modal: 'guide-modals',
  },
} as const;

export { LOCAL_STORAGE };
